import * as types from './mutation-types'
import {SET_CURRENT_RELAY_INTERVALS} from "./mutation-types";

export default {

  [types.LOAD_RELAYS] (state, relays) {
    state.relays = relays
  },

  [types.SET_CURRENT_RELAY_INTERVALS] (state, relayIntervals) {
    state.currentRelayInterval = relayIntervals
  },

  [types.ADD_RELAYS_INTERVALS](state, data) {
    state.relay_intervals = data
  },
}

